module.exports = __webpack_public_path__ + "img/download-on-the-app-store.3f54a97.svg";